// import components
import { TextField as MuiTextField } from '@mui/material';
import { StyledReadModeSkeleton } from './withReadModeField.styles';

// import external libraries
import dayjs from 'dayjs';
import { useFormContext } from 'react-hook-form';
import { useMemo } from 'react';

import type { WithReadModeFieldPropsBase } from './withReadModeField.types';

export const DefaultReadModeRenderer: React.FC<WithReadModeFieldPropsBase> = (
  props
) => {
  const { getValues } = useFormContext();

  if (
    props.options &&
    props.valueGetter &&
    props.labelGetter &&
    props.options.length === 0
  ) {
    return <StyledReadModeSkeleton variant="text" />;
  }

  if (props.options && props.valueGetter && props.labelGetter) {
    const selected = props.options?.find(
      (item) => item[`${props.valueGetter}`] === getValues(props.name)
    );

    return (
      <DefaultReadModeComponent
        {...props}
        value={selected ? selected[props.labelGetter] : undefined}
      />
    );
  }

  const rawValue = getValues(props.name);

  return (
    <DefaultReadModeComponent
      {...props}
      value={props.valueFormatter ? props.valueFormatter(rawValue) : rawValue}
    />
  );
};

export const DefaultReadModeComponent: React.FC<WithReadModeFieldPropsBase> = ({
  label,
  name,
  value,
  disableLabel = false
}) => {
  const { getValues } = useFormContext();

  const renderValue = useMemo(() => {
    if (value) return value;

    let value2 = getValues(name) || '—';
    if (dayjs.isDayjs(value2)) {
      value2 = dayjs(value2).isValid()
        ? dayjs(value2).format('DD-MM-YYYY')
        : '—';
    }
    return value2;
  }, [getValues, name, value]);

  return (
    <MuiTextField
      variant="outlined"
      label={disableLabel ? undefined : label}
      value={renderValue}
      fullWidth
      disabled={true}
      size="small"
      className="read_mode"
    />
  );
};
